import {VGMap} from "../../../../../../modules/index.esm";
import YandexMap from "./YandexMap";

const VGMapLocation = {
	city: App.city || "Москва",
	coordinates: null,
	cities: App.cities || [],
	containers: [],
	isConfirmed: false,

	set: function (data) {
		let _this = this;

		_this = Object.assign({}, _this, data);
		_this.city = _this.geoObjects.get(0).getLocalities().join('');
		_this.coordinates = _this.geoObjects.get(0).geometry.getCoordinates();

		let $cities_container = $('#location-city');
		if ($cities_container) {
			let cities = $cities_container.find('.set-city').filter((i, item) => item.innerHTML === _this.city);

			$('[data-location-confirm]').show();

			if (!cities.length) {
				cities = $cities_container.find('.set-city').map(function (i, item) {
					if (i === 0) return item;
				});
			}

			let id = cities[0].getAttribute('data-id');
			$('[data-location-city]').text(cities[0].innerHTML);

			$(document).on('click', '[data-toggle="location-confirm"]', function () {
				City.setPost(id);

				return false;
			});
		}
	}
}

function onReady() {
	let $maps = document.querySelectorAll('[data-vg-map]');
	if ($maps.length) {
		for (let $map of $maps) {
			new YandexMap().loadIfVisible($map, () => {
				VGMap.init($map);
			});
		}
	}

	// локация пользователя
	if (App.setLocation) {
		new YandexMap().load(() => {
			VGMap.Location.init(function (data) {
				VGMapLocation.set(data);
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", onReady);
